$(function(){
    let productsContainer = $('.products-container'),
        productsInner = $('.products-inner'),
        productsSpinner = $('.products-spinner');

    productsContainer.on('click', '.products-paginate a', loadNextPage);

    async function loadNextPage(e) {
        e.preventDefault();

        let button = $(this),
            url = button.attr('href'),
            container = $('.products-inner'),
            progress = button.siblings('.paginate-progress'),
            spinner = button.siblings('.spinner'),
            paginate = button.parent();

        paginate.css({
            width: paginate.width(),
            height: paginate.height()
        })
        button.hide();
        progress.hide();
        spinner.show();

        let html = await getPage(url),
            productsPagination = productsContainer.find('.products-paginate'),
            products = $(html).find('.products-inner .product').hide(),
            pagination = $(html).find('.products-paginate');

        productsPagination.remove();
        container.find('.products').append(products);
        container.append(pagination);

        products.fadeIn(300);

        paginate.css({
            width: '',
            height: '',
        })

        initLazyLoad();
    }

    function fadePostsOut() {
        return new Promise((resolve) => {
            productsContainer.height(productsContainer.height());
            productsInner.fadeOut(200, function(){
                productsSpinner.fadeIn(200, async function(){
                    resolve();
                });
            })
        })
    }

    function fadePostsIn() {
        return new Promise(resolve => {
            $('.products-spinner').fadeOut(200, function(){
                productsContainer.css('height', '');
                $('.products-inner').fadeIn(200, function(){
                    resolve();
                })
            });
        });
    }

    function getPage(url) {
        return fetch(url)
            .then(response => response.text())
            .then(function (html) {
                return html;
            });
    }
})